<template>
  <div class="right-dialog">
    <div style="width: 100%" v-if="noMake">
      <img style="width: 100%" src="../assets/make/public/right-dialog-mask.png">
      <div class="no-mask-img">
        <img style="width: 100%" src="../assets/make/public/no-mask.png">
        <span style="color:#35315c; opacity:0.4;font-size: 12px">暂未上传图片</span>
      </div>

    </div>
    <div v-if="!noMake" style="position: absolute;width: 100%;height: 100%">
      <div style="position: relative;width: 100%;height: 4%;background-color: #FFFFFF;z-index: 8"></div>
<!--      <div v-show="!bgSwitch&&clothesSwitch" style="position: absolute;width: 100%;height: 14%;background-color: #FFFFFF;z-index: 5"></div>-->
<!--      <div v-show="!clothesSwitch&&!bgSwitch&&beautySwitch" style="position: absolute;width: 100%;height: 24%;background-color: #FFFFFF;z-index: 5"></div>-->
      <div class="right-dialog-item" style="z-index: 7">
        <div @click="clickItem(1)"  class="right-dialog-item-title-contain" :style="{backgroundImage: 'url(' + (bgSwitchItemBg? itemBgUrl : '')  + ')'}">
          <img src="../assets/make/rightDialog/right-dialog-icon-1.png" class="right-dialog-item-icon">
          <div class="right-dialog-item-title">证件照底色</div>
          <img  v-show="bgSwitch" src="../assets/make/rightDialog/right-dialog-open.png" class="right-dialog-item-switch">
          <img  v-show="!bgSwitch" src="../assets/make/rightDialog/right-dialog-close.png" class="right-dialog-item-switch">
        </div>


        <transition name="bgColor">

          <div class="item-contain-bgColor" v-show="bgSwitch&&spec_id">
            <div @click="chooseBgColor(item.name)" :class="item.name==='白'?'bgColor-cube-white':'bgColor-cube'" :style="{backgroundImage:item.colorValue}" :key="index" v-for="(item,index) in bgColor">
              <img v-show="bgColorSelectedName===item.name&&item.name==='白'" style="width: 60%" src="../assets/make/rightDialog/bgColorSelected_white.png">
              <img v-show="bgColorSelectedName===item.name&&item.name!=='白'" style="width: 60%" src="../assets/make/rightDialog/bgColorSelected.png">
            </div>
          </div>


        </transition>

        <transition name="bgColor">
          <div v-show="bgSwitch&&!spec_id" class="bg-no-size-mask">
            <img style="width: 30%;margin-top: 8%" src="../assets/make/public/no-mask.png">
            <span style="font-size: 12px;color: #aaaaaa;line-height: 30px;">暂未选择规格</span>
          </div>
        </transition>
      </div>


      <div style="z-index: 6"  class="right-dialog-item">
        <div @click="clickItem(2)"  class="right-dialog-item-title-contain" :style="{backgroundImage: 'url(' + (clothesSwitchItemBg ? itemBgUrl : '')  + ')'}">
          <img src="../assets/make/rightDialog/right-dialog-icon-2.png" class="right-dialog-item-icon">
          <div style="display: flex" class="right-dialog-item-title">更换正装<div v-show="clothesSwitchItemBg" class="clothes-tip">+￥9.90</div></div>

          <img  v-show="clothesSwitch" src="../assets/make/rightDialog/right-dialog-open.png" class="right-dialog-item-switch">
          <img  v-show="!clothesSwitch" src="../assets/make/rightDialog/right-dialog-close.png" class="right-dialog-item-switch">
        </div>

        <transition name="clothes">
          <div style="padding: 5%;width: 90%" class="item-contain-clothes" v-show="clothesSwitch&&spec_id">
            <div style="width: 100%;display: flex;">
              <div @click="chooseClothesGroup(index)" :class="index===currentClothesGroupIndex?'clothes-group-active':'clothes-group'" :key="index" v-for="(item,index) in clothesList">{{item.group_name}}</div>
            </div>

            <div @click="chooseClothes({clothes_key:'-1'})" :class="clothesId==='-1'?'clothes-cube-active':'clothes-cube'" style="background-size: 100% 100%" :style="{backgroundImage: 'url(' + noClothes  + ')'}"></div>
            <img @click="chooseClothes(item)" :class="clothesId===item.clothes_key?'clothes-cube-active':'clothes-cube'" :src="item.url" :key="index" v-for="(item,index) in currentGroupClothesList">

          </div>

        </transition>
        <transition name="clothes">
          <div v-show="clothesSwitch&&!spec_id" class="clothes-no-size-mask">
            <img style="width: 30%;margin: 25% 0 8% 0" src="../assets/make/public/no-mask.png">
            <span style="font-size: 12px;color: #aaaaaa;line-height: 30px;">暂未选择规格</span>
          </div>
        </transition>
      </div>


      <div style="z-index: 5"  class="right-dialog-item">
        <div @click="clickItem(3)" class="right-dialog-item-title-contain" :style="{backgroundImage: 'url(' + (beautySwitchItemBg ? itemBgUrl : '')  + ')'}">
          <img src="../assets/make/rightDialog/right-dialog-icon-3.png" class="right-dialog-item-icon">
          <div class="right-dialog-item-title">人像美颜</div>
          <img  v-show="beautySwitch" src="../assets/make/rightDialog/right-dialog-open.png" class="right-dialog-item-switch">
          <img  v-show="!beautySwitch" src="../assets/make/rightDialog/right-dialog-close.png" class="right-dialog-item-switch">
        </div>

        <transition name="beauty">
          <div style="padding: 5%;width: 90%" class="item-contain-beauty" v-show="beautySwitch&&spec_id">
            <div class="beauty-item">
              <img style="width: 8%" src="../assets/make/rightDialog/磨皮.png">
              <span style="font-size: 12px;color: #35315C">磨皮</span>
              <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.skinsoft" :max="10" :step="1" :show-tooltip="false"></el-slider>
              <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.skinsoft*10}%`}}</span>
            </div>
            <div class="beauty-item">
              <img style="width: 8%" src="../assets/make/rightDialog/美肤.png">
              <span style="font-size: 12px;color: #35315C">美白</span>
              <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.skinwhite" :max="10" :step="1" :show-tooltip="false"></el-slider>
              <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.skinwhite*10}%`}}</span>
            </div>
            <div class="beauty-item">
              <img style="width: 8%" src="../assets/make/rightDialog/瘦脸.png">
              <span style="font-size: 12px;color: #35315C">瘦脸</span>
              <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.facelift" :max="10" :step="1" :show-tooltip="false"></el-slider>
              <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.facelift*10}%`}}</span>
            </div>
            <div class="beauty-item">
              <img style="width: 8%" src="../assets/make/rightDialog/左眼.png">
              <span style="font-size: 12px;color: #35315C">左眼</span>
              <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.leyelarge" :max="10" :step="1" :show-tooltip="false"></el-slider>
              <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.leyelarge*10}%`}}</span>
            </div><div class="beauty-item">
            <img style="width: 8%" src="../assets/make/rightDialog/右眼.png">
            <span style="font-size: 12px;color: #35315C">右眼</span>
            <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.reyelarge" :max="10" :step="1" :show-tooltip="false"></el-slider>
            <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.reyelarge*10}%`}}</span>
          </div><div class="beauty-item">
            <img style="width: 8%" src="../assets/make/rightDialog/美瞳.png">
            <span style="font-size: 12px;color: #35315C">亮眼</span>
            <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.coseye" :max="10" :step="1" :show-tooltip="false"></el-slider>
            <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.coseye*10}%`}}</span>
          </div>
            <div class="beauty-item">
              <img style="width: 8%" src="../assets/make/rightDialog/嘴型.png">
              <span style="font-size: 12px;color: #35315C">嘴巴</span>
              <el-slider @change="sliderChange" style="width: 53%" v-model="fair_level.mouthlarge" :max="10" :step="1" :show-tooltip="false"></el-slider>
              <span style="font-size: 12px;color: #35315C;opacity: 0.4">{{`${fair_level.mouthlarge*10}%`}}</span>
            </div>



          </div>
        </transition>
        <transition name="beauty">
          <div v-show="beautySwitch&&!spec_id" class="fair-no-size-mask">
            <img style="width: 30%;margin: 35% 0 15% 0" src="../assets/make/public/no-mask.png">
            <span style="font-size: 12px;color: #aaaaaa;line-height: 30px;">暂未选择规格</span>
          </div>
        </transition>
      </div>


    </div>

  </div>
</template>

<script>
    import itemBg from '../assets/make/rightDialog/right-dialog-item-bg.png'
    import utils from "../makeOnlineApi/utils";
    import api from  "../makeOnlineApi/api"
    import noClothes from "../assets/make/preview/no-clothes.png"

    export default {
        name: "RightDialog",
        props:{
            backgroundColor:{
                required:true,
                default:[],
            },
            noMake:{
                required:true,

            },
        },
        data(){
            return{
                spec_id:null,
                itemBgActive:0, // 0未选； 1背景颜色； 2换装；3美颜；
                bgSwitch:false,
                clothesSwitch:false,
                beautySwitch:false,
                bgSwitchItemBg:false,
                clothesSwitchItemBg:false,
                beautySwitchItemBg:false,
                itemBgUrl:itemBg,
                timer:-1,
                bgColor:[



                ],
                bgColorSelectedName:'',
                clothesList:[],
                clothesId:'',
                currentClothesGroupIndex:null,
                currentGroupClothesList:[],

                fair_level:{
                    skinsoft: 1, // 皮肤美肤程度(去皱纹、祛斑等)(0~10)
                    skinwhite: 1, // 皮肤美白程度(0~10)
                    facelift: 1, // 瘦脸程度(0~10)
                    leyelarge: 1, // 左眼放大程度(0~10)
                    reyelarge: 1, // 右眼放大程度(0~10)
                    coseye: 1, // 美瞳程度(0~10)
                    mouthlarge: 1, // 嘴巴缩小程度(0~10)
                },

                noClothes:undefined



            }
        },
        created() {

            this.bgColor=this.$store.state.sizeInfo.spec_id===-4?utils.colorToLinearGradient(this.$store.state.sizeInfo.background_color):this.$store.state.sizeInfo.background_color
            this.bgColorSelectedName=this.$store.state.bgNameSelected
            this.clothesId=this.$store.state.clothesId
            this.fair_level=this.$store.state.fairLevel&&JSON.stringify(this.$store.state.fairLevel)!=='{}'?this.$store.state.fairLevel:
                this.$store.state.appInfo.default_beauty_level
            this.spec_id=this.$store.state.sizeInfo.spec_id
            if (this.$store.state.sizeInfo.spec_id){
                this.openItem(1)
            }
            console.log(this.clothesId)
            this.noClothes=noClothes
        },
        mounted() {
            this.customSliderClass()

        },



        watch:{
            backgroundColor:function(newProps){
                console.log(newProps)
                console.log(this.$store.state.sizeInfo.spec_id===-4?utils.colorToLinearGradient(newProps):newProps)
                this.bgColor=this.$store.state.sizeInfo.spec_id===-4?utils.colorToLinearGradient(newProps):newProps
            },

            itemBgActive:function () {
                clearTimeout(this.timer)
            },
            currentClothesGroupIndex:function (newProps) {

                this.currentGroupClothesList=this.clothesList[newProps].value
            },
            "$store.state.sizeInfo":function (newProps) {
                this.spec_id=newProps.spec_id
                // 选择规格时默认打开 颜色背景版
                if (newProps.spec_id){
                    this.openItem(1)
                }
            },
            "$store.state.clothesId":function (newProps) {
                this.clothesId=newProps
            },
            "$store.state.fairLevel":function (newProps) {
                this.fair_level=newProps
            },
            "$store.state.bgNameSelected":function (newProps) {
                console.log('newProps',newProps)
                this.bgColorSelectedName=newProps
            }
        },
        methods:{
            customSliderClass(){
                const customSliderButton = document.getElementsByClassName('el-slider__button')
                const customSliderBar = document.getElementsByClassName('el-slider__bar')
                const customSliderRunway = document.getElementsByClassName('el-slider__runway')
                for (let i = 0; i < customSliderButton.length; i++) {
                    customSliderButton[i].style.backgroundColor = '#4B00A4'
                    customSliderButton[i].style.borderColor = '#FFFFFF'
                    customSliderButton[i].style.width = '10px'
                    customSliderButton[i].style.height = '10px'
                }
                for (let i = 0; i < customSliderBar.length; i++) {
                    customSliderBar[i].style.backgroundColor = '#4B00A4'
                }
                for (let i = 0; i < customSliderRunway.length; i++) {

                    customSliderRunway[i].style.height = '4px'
                    customSliderRunway[i].style.borderRadius = '2px'
                }
            },
            clickItem(index){
                switch (index) {
                    case 1:
                        if (this.bgSwitch){
                            this.closeItem(index)
                        }else {
                            this.openItem(index)
                        }
                        break;
                    case 2:
                        if (this.clothesSwitch){
                            this.closeItem(index)
                        }else {
                            this.openItem(index)
                        }
                        break;
                    case 3:
                        if (this.beautySwitch){
                            this.closeItem(index)
                        }else {
                            this.openItem(index)
                        }
                        break;
                }
            },
            closeItem(index){
                switch (index) {
                  case 1:
                      this.bgSwitch=false
                      break;
                  case 2:
                      this.clothesSwitch=false
                      break;
                  case 3:
                      this.beautySwitch=false
                      break
                }
                 // 关闭时需要0.5秒的延时，隐藏选中框
                let _this=this
                this.timer= setTimeout(function () {
                    switch (index) {
                        case 1:
                            _this.bgSwitchItemBg=false
                            break;
                        case 2:
                            _this.clothesSwitchItemBg=false
                            break;
                        case 3:
                            _this.beautySwitchItemBg=false
                            break
                    }
                    _this.itemBgActive=index
                },510)
            },
            openItem(index){
                switch (index) {
                    case 1:
                        this.bgSwitch=true
                        this.bgSwitchItemBg=true
                        break;
                    case 2:
                        this.clothesSwitch=true
                        this.clothesSwitchItemBg=true
                        this.clothesList.length===0&&this.getClothesList()
                        break;
                    case 3:
                        this.beautySwitch=true
                        this.beautySwitchItemBg=true
                        break
                }
            },
            getClothesList(){
                api.getClothesList().then(res=>{
                    this.clothesList=res.data.data

                    // 初次进入时默认选中女装
                    this.currentGroupClothesList.length===0&&this.chooseClothesGroup(0)
                })
            },
            chooseClothesGroup(index){

                this.currentClothesGroupIndex=index
            },
            chooseClothes(item){
                console.log('item',item)
                // this.clothesId=item.clothes_key
                this.handleMake({fair_level:this.fair_level,clothesId:item.clothes_key})
            },
            sliderChange(){

                this.handleMake({fair_level:this.fair_level,clothesId:this.clothesId})


            },

            chooseBgColor(name){

                this.$emit('setBgColor',name)
            },

            handleMake(params){
                // this.$store.dispatch('updateClothesId',this.clothesId)
                // this.$store.dispatch('updateFairLevel',this.fair_level)
                this.$emit('handleMake',params)
            }
        },

    }
</script>
<style>
  .el-slider__button.dragging, .el-slider__button.hover, .el-slider__button:hover{
    transform: scale(1);
  }
</style>
<style scoped>
  .right-dialog{
    height: 82.5%;
    width: 20%;
    position: absolute;
    top: 11%;
    right: 0;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 0px 10px #D0D6DF;
    overflow-y: auto;
  }
  .no-mask-img{
    width: 40%;
    position: absolute;
    top:15%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .right-dialog-item{
    width: 100%;
    position: relative;
  }
  .right-dialog-item-title-contain{
    /*background-size: 100% 100%;*/
    /*background-image: url("../assets/make/rightDialog/right-dialog-item-bg.png");*/
    width: 100%;
    height: 8.25vh;

    display: flex;
    align-items: center;
    justify-content: center;

    z-index:6;
    position:relative;
    background-color: white;
    cursor: pointer;
  }
  .right-dialog-item-bg{
    width: 100%;
    height: 100%;

    position: relative;
  }
  .right-dialog-item-icon{

    width: 8%;
    z-index:7


  }
  .right-dialog-item-title{

    width: 55%;
    text-indent: 12px;
    font-size: 12px;
    color: #35315C;
    font-weight: 600;
    z-index:7
  }

  .right-dialog-item-switch{
    width: 8%;
    z-index:7;
    padding-left: 20%;
    cursor: pointer;
  }
  .bgColor-enter-active {
    animation: bgColor-in 0.5s;
  }
  .bgColor-leave-active {
    animation: bgColor-in 0.5s reverse;
  }
  @keyframes bgColor-in {
    0% {
      /*height: 0;*/
      transform: translateY(-100%);
    }

    100% {
      /*height: 100%;*/
      transform: translateY(0px);
    }
  }
  .bg-no-size-mask{
    width: 100%;
    height: 30%;
    background-image: url("../assets/make/rightDialog/bg-no-size-mask.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 4;
  }
  .clothes-no-size-mask{
    width: 100%;
    height: 40%;
    background-image: url("../assets/make/rightDialog/clothes-no-size-mask.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 4;
  }
  .fair-no-size-mask{
    width: 100%;
    height: 40%;
    background-image: url("../assets/make/rightDialog/fair-no-size-mask.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 4;
  }
  .item-contain-bgColor{
    padding: 10% 20% 10% 10%;
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    background-color: #FFFFFF;
    z-index: 4

  }
  .item-contain-clothes{
    padding: 5%;
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    background-color: #FFFFFF;
    z-index: 3
  }
  .item-contain-beauty{
    padding: 5%;
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    background-color: #FFFFFF;
    z-index: 2
  }



  .bgColor-cube{
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 6px;
    border: none;
    cursor: pointer;
  }
  .bgColor-cube-white{
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 6px;
    border: 1px solid #aaaaaa;
    cursor: pointer;
  }

  .clothes-enter-active {
    animation: bgColor-in 0.5s;
  }
  .clothes-leave-active {
    animation: bgColor-in 0.5s reverse;
  }
  @keyframes clothes-in {
    0% {
      /*height: 0;*/
      transform: translateY(-100%);
    }

    100% {
      /*height: 100%;*/
      transform: translateY(0px);
    }
  }

  .clothes-cube{
    width: 20.2%;
    margin:2.3% 4% 2.1% 0;
    border-radius: 2px;
    cursor: pointer;
    height: 3.5vw;
  }
  .clothes-cube-active{
    width: 20.2%;
    margin:2.3% 4% 2.1% 0;
    border-radius: 2px;
    border: 2px solid rgba(75,0,164,1);
    box-sizing: border-box;
    cursor: pointer;
    height: 3.5vw;
  }
  .clothes-group-active{
    width: 16%;
    border-radius: 2px;
    border: 1px solid #FF7BAC;
    color: #FF7BAC;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    margin-right: 5%;
    margin-bottom: 5%;

  }
  .clothes-tip{
    font-size: 12px;line-height: 19px;color: white;background-color: #FF7BAC;text-align: center;border-radius: 2px;margin-left: 5px;
    text-indent: 0;
    font-weight: 400;
    zoom: 0.8;
    padding: 0 3px;
  }
  .clothes-group{
    width: 16%;
    border-radius: 2px;
    border: 1px solid rgba(53,49,92,0.4);
    color: rgba(53,49,92,0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    margin-right: 5%;
    margin-bottom: 5%;
  }


  .beauty-enter-active {
    animation: bgColor-in 0.5s;
  }
  .beauty-leave-active {
    animation: bgColor-in 0.5s reverse;
  }
  @keyframes beauty-in {
    0% {
      transform: translateY(-100%);
      /*height: 0;*/
    }

    100% {
      /*height: 100%;*/
      transform: translateY(0px);
    }
  }
  .beauty-item{
    width: 100%;
    background-color: #F9FAFF;
    height: 45px;
    border-radius: 4px;
    display: flex;
    padding: 0 5%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5%;
  }



</style>
